var map = {
	"./search-results.de-CH.json": 997,
	"./search-results.de-DE.json": 998,
	"./search-results.en-CA.json": 999,
	"./search-results.en-GB.json": 1000,
	"./search-results.en-IN.json": 1001,
	"./search-results.en-ME.json": 1002,
	"./search-results.en-US.json": 1003,
	"./search-results.es-EM.json": 1004,
	"./search-results.es-ES.json": 1005,
	"./search-results.fr-BE.json": 1006,
	"./search-results.fr-CA.json": 1007,
	"./search-results.fr-CH.json": 1008,
	"./search-results.nl-BE.json": 1009,
	"./search-results.nl-NL.json": 1010,
	"./search-results.pl-PL.json": 1011,
	"./search-results.pt-BR.json": 1012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 996;